import type { MapGridProps } from '@Map/shared/MapGrid';
import { MapGridCell } from '@Map/shared/MapGridCell';
import { isOdd } from '@Utils/miscUtils';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { useMapPagePresenter } from '../FloorMap/Components/MapPage/MapPagePresenter';

import type { FloorDepartmentDTO } from '~gateways/ownable.dtos';

type Props = MapGridProps & {
  department: FloorDepartmentDTO;
};
export const MapGridDepartment = observer(function MapGridDepartment({
  department,
  onPress,
  cellSize,
  gapSize = 5,
  borderRadius = 30,
}: Props) {
  const { borders, notches } = useMapPagePresenter();

  return (
    <>
      {department.blockCoordinates.map((coord, index, coords) => {
        // Skip odd indexes, since they are the y coordinates
        if (isOdd(index)) {
          return null;
        }

        const y = coords[index + 1];
        const x = coord;

        const borderSet = borders[x][y];

        return (
          <MapGridCell
            key={`${x}-${y}`}
            x={x}
            y={y}
            borderSet={borderSet}
            cellSize={cellSize}
            gapSize={gapSize}
            borderRadius={borderRadius}
            onPress={() => onPress?.(department.departmentId)}
            notches={notches[x][y]}
          />
        );
      })}
    </>
  );
});
